import { Injectable } from '@angular/core';


@Injectable(
	{
		providedIn: 'root'
	})


export class CreateAccountService 
{
	private readonly key: string = "insWiz";
	constructor() { this.initIfNeeded() }


	private initIfNeeded() {

		if (!sessionStorage.getItem(this.key)) {
			const emptyStructure = {};
			sessionStorage.setItem(this.key, JSON.stringify(emptyStructure));
		}
	}

	public isKeyEmpty()
	{
		const stored = sessionStorage.getItem(this.key);
		if (stored === null) return false; // key missing — not the same as {} (adjust if you want true)
		try 
		{
			const parsed = JSON.parse(stored);
			return parsed && typeof parsed === 'object' && !Array.isArray(parsed) && Object.keys(parsed).length === 0;
		}
		catch
		{
			return false; // not valid JSON
		}
	}

	public cleanMemory() {
		sessionStorage.removeItem(this.key);
	}

	public memorizeAnObject(key: string, data: any) {
		let insWizObj: any = {};
		const stored = sessionStorage.getItem(this.key);
		if (stored) {
			try {
				insWizObj = JSON.parse(stored);
			} catch {
				insWizObj = {};
			}
		}
		insWizObj[key] = { ...data }; // Always wrap value in an object
		sessionStorage.setItem(this.key, JSON.stringify(insWizObj));
	}

	public doWeHaveMemory(keyToFind: string): boolean {
		const stored = sessionStorage.getItem(this.key);
		if (!stored) return false;
		try {
			const insWizObj = JSON.parse(stored);
			return insWizObj.hasOwnProperty(keyToFind);
		} catch {
			return false;
		}
	}

	public readObject(key: string) 
	{
		const stored = sessionStorage.getItem(this.key);
		if (stored)
		{
			let insWizObj: any = {};
			try 
			{
				insWizObj = JSON.parse(stored);
			}
			catch 
			{
				return null;
			}
			if (insWizObj.hasOwnProperty(key) && typeof insWizObj[key] === 'object' && insWizObj[key] !== null) 
			{
				const inner = insWizObj[key]; // Return the value inside the outer object
				const values = Object.values(inner); // If the object has only one key, return its value, else return the object itself

				return values.length === 1 ? values[0] : inner;
			}
		}
		return null;
	}
}



